module.exports = __webpack_public_path__ + "img/altv-logo-light.28edbe88.png";